import {
    Container
} from '@mui/material';
import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import {BeginList} from '../texts/begin';
import {questionList} from '../texts/questions';
import styles from '../Quiz.module.css'
import {
    // goToResult,
    nextQuestion,
    selectCharacter,
    selectQuestionIndex,
    saveAnswer,
    selectAnswers,
    goToResult,
} from '../quizSlice';
import {
    QuestionList,
    QuestionType,
} from '../types';
import { CSSTransition } from 'react-transition-group';
import {
    load,
} from '../utils';
import {Header} from './Header';
import { Loader } from './Loader';
import Ornament1 from '../img/orn1.svg';
import Cover from '../img/cover.jpg';




export const Question = () => {
    const dispatch = useAppDispatch();

    const questionIndex = useAppSelector(selectQuestionIndex);
    const characterId = useAppSelector(selectCharacter);
    const answers = useAppSelector(selectAnswers);

    const [item, setItem] = useState<QuestionType | undefined>(undefined);
    const [inProp, setInProp] = useState<boolean>(false);
    const [bg, setBg] = useState(Cover);
    const [loading, setLoading] = useState(true);
    const [answerId, setAnswerId] =  useState(0);

    const questions: QuestionList = useMemo(()=>{
        return [...BeginList,...questionList]
    }, []);

    useEffect(() => {
        const itemFound = questions.find(q => q.id === questionIndex);
        if (!itemFound) return;

        setItem(itemFound);
        window.scrollTo(0, 0);

    }, [dispatch, questionIndex, questions, inProp, item, bg])

    useEffect(() => {
        setInProp(prev => !prev);
    }, [questionIndex])

    useEffect(() => {
        setInProp(false);
        load(bg, 200)
            .then( ()=> {
                setLoading(false);
                setInProp(true)
            }).catch(err => console.error(err));

    }, [bg])


    useEffect(() => {
        document.getElementById('containerToScroll')?.scrollIntoView({ behavior: 'smooth' });
    }, [answers])


    const handleAnswerClick = useCallback((id: number) => {
        setAnswerId(id);
        if(!questionIndex){
            dispatch(nextQuestion(questionIndex+1))
        }
        dispatch(saveAnswer(id))
    }, [dispatch, questionIndex]);

    const handleNextClick = useCallback(()=>{
        if(questionIndex !== questions.length-1){
            dispatch(nextQuestion(questionIndex+1))
        }
        else {
            dispatch(goToResult())
        }
        setAnswerId(0);
    }, [dispatch, questionIndex, questions.length]);


    const questionsMarkup = useMemo(() => {
        return <div className={styles.questionContainer} style={{ backgroundImage: `url(${bg})` }}>
            <div className={styles.blur} style={{opacity: characterId?0:1 }} ></div>
            <Header />
            <CSSTransition in={inProp} timeout={1000} classNames="card">
                <div className={`${styles.question} card`}>
                    <div className = {styles.ornament}>
                        <img src={item?.img || Ornament1} alt="" />
                    </div>
                    <Container maxWidth="md">
                        <div  className = {styles.df}>
                            <div className={styles.questionText}>
                                <div className={questionIndex ? 'gra' : ''} dangerouslySetInnerHTML={{ __html: item?.question || '' }} />
                            </div>
                        </div>

                        <ul className={styles.answerContainer} >
                             {item?.answers.map((answer) => {
                                let buttonClassName = (answers[questionIndex] && item?.rightAnswerId === answer.id) || !questionIndex? styles.rightAnswer: '';

                                return <li className={`${styles.answer}`} key={answer.id}>
                                    <button onClick={() => handleAnswerClick(answer.id)} disabled={!!answers[questionIndex]}
                                    className={`${buttonClassName} ${answer.id === answerId && answerId !==item?.rightAnswerId? styles.wrongAnswer: '' } ${questionIndex ? '' : styles.startButton}`}
                                    >
                                       <div dangerouslySetInnerHTML={{ __html: answer.text|| '' }}></div>
                                    </button>
                                </li>
                            })}
                        </ul>

                        {answers[questionIndex] && <div  className = {styles.df} id={'containerToScroll'}>
                            <div className={styles.questionText}>
                                <div  dangerouslySetInnerHTML={{ __html: item?.rightAnswerExplanation || '' }} />
                                <img src={item?.rightAnswerImg} alt=""/>
                                <button onClick={handleNextClick} className={styles.nextButton}>
                                    Далі <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
                                </button>
                            </div>
                        </div>}

                    </Container>
                </div>

            </CSSTransition>
        </div>
    }, [answerId, answers, bg, characterId, handleAnswerClick, handleNextClick, inProp, item?.answers, item?.img, item?.question, item?.rightAnswerExplanation, item?.rightAnswerId, item?.rightAnswerImg, questionIndex]);

    return <>
        <CSSTransition in={!loading} timeout={1000} classNames="card">
            <div className='card'>
                {loading ? <Loader /> : questionsMarkup}
            </div>

        </CSSTransition>
    </>




}
